/******************************************************************************
   NAME:       TSVH
   AUTHOR:     Duynh
******************************************************************************/

import { Component, OnInit, Input, ViewEncapsulation, OnChanges, SimpleChanges } from '@angular/core';
import { MessageService } from 'primeng/components/common/messageservice';
import { Message } from 'primeng/components/common/message';
import { UserService, DanhMucService, DatetimeService, TSVHService } from 'app/services/index';
import { environment } from 'environments/environment';
import { PageChangedEvent } from 'ngx-bootstrap/pagination/pagination.component';
import { Chart } from 'chart.js';

const userLocalName = environment.LOCAL_USER_NAME;

@Component({
  selector: 'app-thongsovanhanh-chitiet',
  templateUrl: './thongsovanhanh-chitiet.component.html',
  styleUrls: ['./thongsovanhanh-chitiet.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TSVHChiTietComponent implements OnInit, OnChanges {

  chart: any = [];
  chartDrew: boolean = false;

  isShowProgress: number = 0;
  paraQueryTuNgay: any;
  paraQueryDenNgay: any;
  lstTsvh: any = [];
  lstReturnTsvh: any = [];
  lstTsvh_bieudo: any = [];
  lstSocongto: any = [];

  totalRows: number = 0;
  totalPage: number = 0;
  currentPage: number = 0;

  maxDate: Date;
  loaiThongsotsvh: string = "u";
  dataExcel: string;
  isDataAvailable: boolean = false;
  paraQuerySocongto: any;
  rowsNumber: number = 20;

  @Input() nhompha: number = 1;
  @Input() meterid: number;
  @Input() tendiemdo: number;
  @Input() selected_date: Date;

  msgs: Message[];

  constructor(
    private user: UserService,
    private danhMucService: DanhMucService,
    private dateService: DatetimeService,
    private tsvhService: TSVHService) {
  }

  public chartOptions: any;


  // event

  ngOnInit() {
    this.maxDate = new Date();
    this.paraQueryTuNgay = this.selected_date;
    this.paraQueryDenNgay = this.selected_date;
    this.paraQuerySocongto = '0';
  }
  ngOnChanges(changes: SimpleChanges) {
    this.layDScongto();
  }
  public chartTypeChange() {
    if (this.nhompha == 3)
      this.drawChart3phase();
    else
      this.drawChart1phase();
  }

  public onPageChange(page): void {
    page = Number(page);

    if (this.isShowProgress === 1) return;
    if (this.totalRows <= 0) return;
    if (page < 0) return;
    if (page > this.totalPage - 1) return;
    if (page === this.currentPage) return;

    this.loadPage(page);
  }


  public onSizeChange() {
    this.rowsNumber = Number(this.rowsNumber);
    this.currentPage = 0;
    this.loadPage(0);
  }


  public thuchien(): void {
    this.laydulieu();
  }

  public layDScongto(): void {
    this.meterid
    this.tsvhService.getDsCongto(
      this.meterid).subscribe(response => {
        let dataRet = (response);
        this.lstSocongto = [];
        this.lstSocongto.push({ label: "--Tất cả--", value: 0 });
        dataRet.data.forEach((item, index) => {
          this.lstSocongto.push({ label: item.socongto, value: item.sct_value });
        });
        this.laydulieu();
      });
  }

  public laydulieu() {
    this.msgs = [];

    const diff = this.paraQueryDenNgay - this.paraQueryTuNgay;

    if (diff < 0) {
      this.msgs.push({
        severity: 'error',
        summary: 'Thông báo',
        detail: 'Vui lòng "Từ ngày" nhỏ hơn "Đến ngày"'
      });
      return;
    }

    this.currentPage = 0;
    this.loadPage(0);
    this.laydulieu_bieudo();

  }
  private loadPage(page: number = 0) {

    this.isShowProgress = 1;

    const curUser = JSON.parse(localStorage.getItem(userLocalName));

    const pageSize = Number(this.rowsNumber);

    const skip = page;
    const limit = pageSize;

    this.tsvhService.getTSVH_KHACHHANG(
      curUser.mataikhoan,
      this.meterid,
      this.paraQuerySocongto,
      this.dateService.convertDatetoDateOnlyString(this.paraQueryTuNgay),
      this.dateService.convertDatetoDateOnlyString(this.paraQueryDenNgay),
      skip, limit, "", this.nhompha).subscribe(response => {
        let dataRet = (response);
        if (dataRet.data.length > 0) {
          this.lstTsvh = dataRet.data;
          this.lstReturnTsvh = dataRet.data;
          this.currentPage = page;
          this.totalRows = dataRet.data[0].rowscount || 0;
          this.totalPage = Math.ceil(this.totalRows / pageSize);


        }
        else {
          this.lstTsvh = [];
          this.dataExcel = "";
          this.lstReturnTsvh = [];
          this.currentPage = 0;
          this.totalRows = 0;
          this.totalPage = 0;
          if (this.chartDrew) {
            this.chart.destroy();
            this.chartDrew = false;
          }
        }
        this.isShowProgress = 0;
      });
  }

  public laydulieu_bieudo() {
    this.isShowProgress = 1;
    let diff = this.paraQueryDenNgay - this.paraQueryTuNgay;
    if (diff < 0) {
      return;
    }
    let curUser = JSON.parse(localStorage.getItem(userLocalName));
    this.tsvhService.getTSVH_KHACHHANG_BieuDo(
      curUser.mataikhoan,
      this.meterid,
      this.paraQuerySocongto = undefined ? '0' : this.paraQuerySocongto,
      this.dateService.convertDatetoDateOnlyString(this.paraQueryTuNgay),
      this.dateService.convertDatetoDateOnlyString(this.paraQueryDenNgay), "").subscribe(response => {

        let dataRet = (response);
        if (dataRet.data.length > 0) {
          this.lstTsvh_bieudo = dataRet.data;
          this.chartTypeChange();
        }
        else {
          this.lstTsvh_bieudo = [];
        }
        this.isShowProgress = 0;
      });
  }

  public excelTsvh() {
    this.isShowProgress = 1;
    let curUser = JSON.parse(localStorage.getItem(userLocalName));
    let title = "THÔNG SỐ VẬN HÀNH";
    let header = "";
    let ngayxuatdulieu: Date = new Date();
    if (this.paraQueryTuNgay == this.paraQueryDenNgay) {
      header = this.tendiemdo + ",Ngày xuất dữ liệu: " + this.dateService.convertDatetoDateOnlyString(ngayxuatdulieu) + ",Có " + this.totalRows + " bản ghi trong ngày: " + this.dateService.convertDatetoDateOnlyString(this.paraQueryTuNgay);
    } else {
      header = this.tendiemdo + ",Ngày xuất dữ liệu: " + this.dateService.convertDatetoDateOnlyString(ngayxuatdulieu) + ",Có " + this.totalRows + " bản ghi. Từ ngày: " + this.dateService.convertDatetoDateOnlyString(this.paraQueryTuNgay) + " - Đến ngày: " + this.dateService.convertDatetoDateOnlyString(this.paraQueryDenNgay);
    }
    this.tsvhService.getTSVH_EXCEL_KHACHHANG(this.meterid
      , title
      , this.tendiemdo + ' - THÔNG SỐ VẬN HÀNH -  Từ ngày: ' + this.dateService.convertDatetoDateOnlyString(this.paraQueryTuNgay) + " Đến ngày: " + this.dateService.convertDatetoDateOnlyString(this.paraQueryDenNgay) + '.xlsx'
      , this.dateService.convertDatetoDateOnlyString(this.paraQueryTuNgay)
      , this.dateService.convertDatetoDateOnlyString(this.paraQueryDenNgay)
      , this.nhompha, 0, 20000, this.paraQuerySocongto, curUser.mataikhoan, "", header).subscribe(response => {

        this.isShowProgress = 0;
      });
  }

  public drawChart3phase() {

    if (this.lstTsvh_bieudo.length == 0) {
      if (this.chartDrew) {
        this.chart.destroy();
        this.chartDrew = false;
      }
      return;
    }

    let labels = [];
    let dataPhaA = [];
    let dataPhaB = [];
    let dataPhaC = [];
    let donvi_doluong: string = "";
    // this.lstTsvh_bieudo.reverse();
    this.lstTsvh_bieudo.forEach((item, index) => {
      labels.push(item.time);

      switch (this.loaiThongsotsvh) {
        case "u": {
          dataPhaA.push(item.ua);
          dataPhaB.push(item.ub);
          dataPhaC.push(item.uc);
          donvi_doluong = "Điện áp (V)";
          break;
        }
        case "i": {
          dataPhaA.push(item.ia);
          dataPhaB.push(item.ib);
          dataPhaC.push(item.ic);
          donvi_doluong = "Dòng điện (A)";
          break;
        }
        case "cos": {
          dataPhaA.push(item.cosa);
          dataPhaB.push(item.cosb);
          dataPhaC.push(item.cosc);
          donvi_doluong = "Hệ số cos";
          break;
        }
        case "p": {
          dataPhaA.push(item.pa);
          dataPhaB.push(item.pb);
          dataPhaC.push(item.pc);
          donvi_doluong = "P(Kw)";
          break;
        }
        case "q": {
          dataPhaA.push(item.qa);
          dataPhaB.push(item.qb);
          dataPhaC.push(item.qc);
          donvi_doluong = "Q(Kvar)";
          break;
        }
      };
    });

    //  this.lstTsvh_bieudo.reverse();

    if (this.chartDrew) {
      this.chart.destroy();
      this.chartDrew = false;
    }
    this.chart = new Chart('canvas', {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          {
            label: 'Pha A',
            data: dataPhaA,
            fill: false,
            borderColor: '#f0ad4e'
          },
          {
            label: 'Pha B',
            data: dataPhaB,
            fill: false,
            borderColor: '#5cb85c'
          },
          {
            label: 'Pha C',
            data: dataPhaC,
            fill: false,
            borderColor: '#d9534f'
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
            }
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: donvi_doluong
            }
          }]
        },
        chartArea: {
          backgroundColor: '#FFF'
        }
      },
      plugins: [{
        beforeInit: function (chart, options) {

        },
        beforeDraw: function (chart, easing) {
          if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
            var helpers = Chart.helpers;
            var ctx = chart.chart.ctx;
            //var chartArea = chart.chartArea;
            var canvas = chart.chart.canvas


            ctx.save();
            ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.restore();
          }
        }
      }]
    })
    this.chartDrew = true;
  }

  public drawChart1phase() {

    if (this.lstTsvh_bieudo.length == 0) {
      if (this.chartDrew) {
        this.chart.destroy();
        this.chartDrew = false;
      }
      return;
    }

    let labels = [];
    let data1Pha = [];
    let donvi_doluong: string = "";

    //  this.lstTsvh_bieudo.reverse();


    this.lstTsvh_bieudo.forEach((item, index) => {
      labels.push(item.time);

      switch (this.loaiThongsotsvh) {
        case "u": {
          data1Pha.push(item.ua);
          donvi_doluong = "Điện áp (V)";
          break;
        }
        case "i": {
          data1Pha.push(item.ia);
          donvi_doluong = "Dòng điện (A)";
          break;
        }
        case "cos": {
          data1Pha.push(item.cosa);
          donvi_doluong = "Hệ số cos";
          break;
        }
        case "pgiaotong": {
          data1Pha.push(item.pgiaotong);
          donvi_doluong = "P (KwH)";
          break;
        }
      };
    });

    //  this.lstTsvh_bieudo.reverse();


    if (this.chartDrew) {
      this.chart.destroy();
      this.chartDrew = false;
    }
    this.chart = new Chart('canvastsvh', {
      type: 'line',
      data: {
        labels: labels,
        datasets: [
          {
            label: '1 Pha',
            data: data1Pha,
            fill: false,
            borderColor: '#0275d8'
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
            }
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: donvi_doluong
            }
          }]
        },
        chartArea: {
          backgroundColor: '#FFF'
        }
      },
      plugins: [{
        beforeInit: function (chart, options) {

        },
        beforeDraw: function (chart, easing) {
          if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
            var helpers = Chart.helpers;
            var ctx = chart.chart.ctx;
            //var chartArea = chart.chartArea;
            var canvas = chart.chart.canvas


            ctx.save();
            ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.restore();
          }
        }
      }]
    })
    this.chartDrew = true;

  }

  public retNull(number) {
    if (number == null || number == undefined) {
      return '-';
    }
    return number;
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/views/giam-sat/thong-so-van-hanh/chi-tiet/thongsovanhanh-chitiet.component.ts